import classNames from "classnames";
import {ElementType, useContext} from "react";
import {AccordionContext, useAccordionButton} from "react-bootstrap";
import AccordionItemContext from "react-bootstrap/AccordionItemContext";

import {AccordionStyleContext} from "@/components/accordion/Accordion.tsx";
import {AccordionHeaderProps} from "@/components/accordion/subComponents/AccordionHeader/AccordionHeader.types.ts";
import {AccordionHeaderIcon} from "@/components/accordion/subComponents/AccordionHeader/AccordionHeaderIcon.tsx";

import styles from "./AccordionHeader.module.scss";

const AccordionHeader = <T extends ElementType = "div">({
  as,
  children,
  callback,
  className,
  reverse = false,
  iconInitialAngle,
  iconActiveAngle,
  ...props
}: AccordionHeaderProps<T>) => {
  const {activeEventKey} = useContext(AccordionContext);
  const {eventKey} = useContext(AccordionItemContext);
  const style = useContext(AccordionStyleContext);
  const accordionOnClick = useAccordionButton(eventKey, () => callback && callback(eventKey));
  const Element = as || "div";
  const isActive = activeEventKey === eventKey;

  return (
    <Element
      className={classNames(styles[style.variant ?? "default"], className, "d-flex align-items-center")}
      onClick={accordionOnClick}
      role={"button"}
      aria-expanded={isActive}
      aria-controls={`accordion-${eventKey}`}
      {...props}
    >
      {reverse && (
        <AccordionHeaderIcon
          isActive={isActive}
          iconInitialAngle={iconInitialAngle}
          iconActiveAngle={iconActiveAngle}
        />
      )}
      {children}
      {!reverse && (
        <AccordionHeaderIcon
          isActive={isActive}
          iconInitialAngle={iconInitialAngle}
          iconActiveAngle={iconActiveAngle}
          className="ms-auto"
        />
      )}
    </Element>
  );
};

AccordionHeader.displayName = "AccordionHeader";
export {AccordionHeader};
